import Container from 'typedi';
import LogRepository from '../repositories/LogRepository';
class LogService {
  logRepository;
  constructor() {
    this.logRepository = Container.get(LogRepository);
  }
  sendInfo = (message) => this.logRepository.sendInfo(message);
  sendError = (message) => this.logRepository.sendError(message);
}

Container.set({ id: LogService, type: LogService });

export default LogService;